(function () {
  // 1) Seletores mais comuns do T4S
  const ATC_SELECTORS = [
    'a.t4s-pr-addtocart',
    '[data-action-atc]',
    'button[name="add"][type="submit"]'
  ];

  function findVariantId(btn) {
    // T4S costuma usar data-variant-id em vários lugares
    let id =
      btn.getAttribute('data-variant-id') ||
      btn.dataset.variantId ||
      btn.getAttribute('data-id') ||
      btn.dataset.id;

    // Se estiver dentro de um form / select de variantes
    if (!id) {
      const form = btn.closest('form');
      if (form) {
        const variantInput =
          form.querySelector('input[name="id"]') ||
          form.querySelector('select[name="id"]');
        if (variantInput) id = variantInput.value;
      }
    }

    return id ? String(id).trim() : null;
  }

  function findQty(btn) {
    const wrap = btn.closest('form') || btn.closest('[data-quantity-wrapper]') || document;
    const qtyEl = wrap.querySelector('input[name="quantity"], [data-quantity-value]');
    const qty = qtyEl ? parseInt(qtyEl.value || qtyEl.getAttribute('value') || '1', 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  async function addToCartAjax(variantId, qty) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    });

    if (!res.ok) {
      let msg = 'Falha ao adicionar no carrinho.';
      try {
        const data = await res.json();
        if (data && data.description) msg = data.description;
      } catch (_) {}
      throw new Error(msg);
    }

    return res.json();
  }

  function openMiniCart() {
    // Tenta “chamar” o drawer do tema por eventos / gatilhos comuns
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:open'));

    // Muitos temas T4S abrem drawer ao clicar no ícone do carrinho
    const cartIcon =
      document.querySelector('[data-drawer-cart-open]') ||
      document.querySelector('a[href*="/cart"]') ||
      document.querySelector('[data-header-cart]');

    if (cartIcon) cartIcon.click();
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest(ATC_SELECTORS.join(','));
    if (!btn) return;

    // evita capturar botões que *realmente* deveriam navegar
    // (ex: "ver produto")
    const href = btn.getAttribute('href');
    const looksLikeAtc = btn.classList.contains('t4s-pr-addtocart') || btn.hasAttribute('data-action-atc');
    if (href && !looksLikeAtc && href.indexOf('/products/') >= 0) return;

    const variantId = findVariantId(btn);
    if (!variantId) return; // sem variant, deixa o tema fazer o padrão

    e.preventDefault();
    e.stopPropagation();

    btn.classList.add('is--loading');
    try {
      const qty = findQty(btn);
      await addToCartAjax(variantId, qty);
      openMiniCart();
    } catch (err) {
      console.warn(err);
      alert(err.message || 'Erro ao adicionar no carrinho.');
    } finally {
      btn.classList.remove('is--loading');
    }
  }, true);
})();
